module.exports = __webpack_public_path__ + "static/img/layer8.fe21978a.png";